import script from "./Talk.vue?vue&type=script&lang=ts&setup=true"
export * from "./Talk.vue?vue&type=script&lang=ts&setup=true"

import "./Talk.vue?vue&type=style&index=0&id=b31d1a0e&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b31d1a0e"]])

export default __exports__